import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const GoogleNewsIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <defs>
                <clipPath id="a">
                    <rect x="0.18" y="1.02" width="9.64" height="7.96" fill="none" />
                </clipPath>
                <radialGradient
                    id="b"
                    cx="-947.74"
                    cy="534.66"
                    r="0.11"
                    gradientTransform="matrix(83.63, 0, 0, -84.39, 79265.19, 45122.23)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#fff" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
            </defs>
            <g clipPath="url(#a)">
                <path d="M7.85,6.42a.25.25,0,0,1-.25.25H2.4a.25.25,0,0,1-.25-.25V1.27A.25.25,0,0,1,2.4,1H7.6a.25.25,0,0,1,.25.25V6.42Z" fill="#0c9d58" />
                <path d="M7.85,2.35,5.9,2.09l1.95.53Z" fill="#004d40" opacity="0.2" />
                <path d="M5.09,1.29,2.14,2.62,5.4,1.42h0A.23.23,0,0,0,5.09,1.29Z" fill="#004d40" opacity="0.2" />
                <path d="M7.6,1H2.4a.25.25,0,0,0-.25.25v.05a.25.25,0,0,1,.25-.24H7.6a.25.25,0,0,1,.25.24V1.27A.25.25,0,0,0,7.6,1Z" fill="#fff" opacity="0.2" />
                <path
                    d="M3.41,6.26a.25.25,0,0,0,.16.3L8.39,7.87a.24.24,0,0,0,.28-.18L9.81,3.41a.23.23,0,0,0-.16-.3L4.83,1.8A.24.24,0,0,0,4.55,2Z"
                    fill="#ea4335"
                />
                <path d="M8.72,4.94,9,6.49l-.26,1Z" fill="#3e2723" opacity="0.2" />
                <path d="M5.92,2.16l.23.06.14,1Z" fill="#3e2723" opacity="0.2" />
                <path
                    d="M9.65,3.11,4.83,1.8A.24.24,0,0,0,4.55,2L3.42,6.26v0L4.54,2a.23.23,0,0,1,.28-.18L9.64,3.17a.23.23,0,0,1,.16.27v0A.23.23,0,0,0,9.65,3.11Z"
                    fill="#fff"
                    opacity="0.2"
                />
                <path d="M7.21,5.73a.25.25,0,0,1-.13.32L2,7.91a.23.23,0,0,1-.3-.15L.2,3.6a.23.23,0,0,1,.13-.31L5.41,1.42a.25.25,0,0,1,.3.15Z" fill="#ffc107" />
                <path
                    d="M.22,3.65a.23.23,0,0,1,.13-.31L5.43,1.47a.25.25,0,0,1,.3.15l0-.05a.25.25,0,0,0-.3-.15L.33,3.29A.23.23,0,0,0,.2,3.6L1.7,7.76h0Z"
                    fill="#fff"
                    opacity="0.2"
                />
                <path d="M8.72,8.73A.25.25,0,0,1,8.48,9h-7a.25.25,0,0,1-.24-.25V3.43a.25.25,0,0,1,.24-.25h7a.25.25,0,0,1,.24.25Z" fill="#4285f4" />
                <path d="M7.4,5.28H5.31V4.72H7.4a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.4,5.28Z" fill="#fff" />
                <path d="M7.4,7.38H5.31V6.82H7.4a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.4,7.38Z" fill="#fff" />
                <path d="M7.72,6.33H5.31V5.77H7.72a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.72,6.33Z" fill="#fff" />
                <path
                    d="M8.48,8.92h-7a.25.25,0,0,1-.24-.25v.06A.25.25,0,0,0,1.52,9h7a.25.25,0,0,0,.24-.25V8.67A.25.25,0,0,1,8.48,8.92Z"
                    fill="#1a237e"
                    opacity="0.2"
                />
                <path d="M1.52,3.23h7a.25.25,0,0,1,.24.25v0a.25.25,0,0,0-.24-.25h-7a.25.25,0,0,0-.24.25v0A.25.25,0,0,1,1.52,3.23Z" fill="#fff" opacity="0.2" />
                <path
                    d="M3.45,5.83v.5h.71a.67.67,0,0,1-.71.52.8.8,0,0,1,0-1.6.73.73,0,0,1,.51.2H4l.37-.38a1.27,1.27,0,0,0-.88-.35,1.33,1.33,0,0,0,0,2.66,1.22,1.22,0,0,0,1.26-1.3,2,2,0,0,0,0-.25Z"
                    fill="#fff"
                />
                <g opacity="0.2">
                    <path d="M3.47,6.33v0h.69l0,0Z" fill="#1a237e" opacity="0.2" />
                    <path
                        d="M3.47,7.38a1.33,1.33,0,0,1-1.32-1.3v0A1.32,1.32,0,0,0,3.47,7.43,1.21,1.21,0,0,0,4.72,6.14v0A1.21,1.21,0,0,1,3.47,7.38Z"
                        fill="#1a237e"
                        opacity="0.2"
                    />
                    <path
                        d="M4,5.45a.72.72,0,0,0-.5-.2.8.8,0,0,0-.78.8v0a.8.8,0,0,1,.78-.78.72.72,0,0,1,.5.2H4l.4-.4,0,0L4,5.45Z"
                        fill="#1a237e"
                        opacity="0.2"
                    />
                </g>
                <path d="M7.51,5.22v0a.11.11,0,0,1-.11.11H5.31v0H7.4A.11.11,0,0,0,7.51,5.22Z" fill="#1a237e" opacity="0.2" />
                <path d="M7.4,7.38H5.31v0H7.4a.11.11,0,0,0,.11-.11V7.27A.11.11,0,0,1,7.4,7.38Z" fill="#1a237e" opacity="0.2" />
                <path d="M7.72,6.33H5.31v0H7.72a.11.11,0,0,0,.11-.11v0A.11.11,0,0,1,7.72,6.33Z" fill="#1a237e" opacity="0.2" />
                <path
                    d="M9.65,3.11l-1.8-.49V1.27A.25.25,0,0,0,7.6,1H2.4a.25.25,0,0,0-.25.25V2.62L.33,3.29A.23.23,0,0,0,.2,3.6l1.08,3V8.73A.25.25,0,0,0,1.52,9h7a.25.25,0,0,0,.24-.25V7.5L9.81,3.41A.23.23,0,0,0,9.65,3.11Z"
                    fill="url(#b)"
                />
            </g>
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const GoogleNewsIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <defs>
                <clipPath id="a">
                    <rect x="0.18" y="1.02" width="9.64" height="7.96" fill="none" />
                </clipPath>
                <radialGradient
                    id="b"
                    cx="-947.74"
                    cy="534.66"
                    r="0.11"
                    gradientTransform="matrix(83.63, 0, 0, -84.39, 79265.19, 45122.23)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#fff" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
            </defs>
            <g clipPath="url(#a)">
                <path d="M7.85,6.42a.25.25,0,0,1-.25.25H2.4a.25.25,0,0,1-.25-.25V1.27A.25.25,0,0,1,2.4,1H7.6a.25.25,0,0,1,.25.25V6.42Z" fill="#0c9d58" />
                <path d="M7.85,2.35,5.9,2.09l1.95.53Z" fill="#004d40" opacity="0.2" />
                <path d="M5.09,1.29,2.14,2.62,5.4,1.42h0A.23.23,0,0,0,5.09,1.29Z" fill="#004d40" opacity="0.2" />
                <path d="M7.6,1H2.4a.25.25,0,0,0-.25.25v.05a.25.25,0,0,1,.25-.24H7.6a.25.25,0,0,1,.25.24V1.27A.25.25,0,0,0,7.6,1Z" fill="#fff" opacity="0.2" />
                <path
                    d="M3.41,6.26a.25.25,0,0,0,.16.3L8.39,7.87a.24.24,0,0,0,.28-.18L9.81,3.41a.23.23,0,0,0-.16-.3L4.83,1.8A.24.24,0,0,0,4.55,2Z"
                    fill="#ea4335"
                />
                <path d="M8.72,4.94,9,6.49l-.26,1Z" fill="#3e2723" opacity="0.2" />
                <path d="M5.92,2.16l.23.06.14,1Z" fill="#3e2723" opacity="0.2" />
                <path
                    d="M9.65,3.11,4.83,1.8A.24.24,0,0,0,4.55,2L3.42,6.26v0L4.54,2a.23.23,0,0,1,.28-.18L9.64,3.17a.23.23,0,0,1,.16.27v0A.23.23,0,0,0,9.65,3.11Z"
                    fill="#fff"
                    opacity="0.2"
                />
                <path d="M7.21,5.73a.25.25,0,0,1-.13.32L2,7.91a.23.23,0,0,1-.3-.15L.2,3.6a.23.23,0,0,1,.13-.31L5.41,1.42a.25.25,0,0,1,.3.15Z" fill="#ffc107" />
                <path
                    d="M.22,3.65a.23.23,0,0,1,.13-.31L5.43,1.47a.25.25,0,0,1,.3.15l0-.05a.25.25,0,0,0-.3-.15L.33,3.29A.23.23,0,0,0,.2,3.6L1.7,7.76h0Z"
                    fill="#fff"
                    opacity="0.2"
                />
                <path d="M8.72,8.73A.25.25,0,0,1,8.48,9h-7a.25.25,0,0,1-.24-.25V3.43a.25.25,0,0,1,.24-.25h7a.25.25,0,0,1,.24.25Z" fill="#4285f4" />
                <path d="M7.4,5.28H5.31V4.72H7.4a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.4,5.28Z" fill="#fff" />
                <path d="M7.4,7.38H5.31V6.82H7.4a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.4,7.38Z" fill="#fff" />
                <path d="M7.72,6.33H5.31V5.77H7.72a.11.11,0,0,1,.11.11v.34A.11.11,0,0,1,7.72,6.33Z" fill="#fff" />
                <path
                    d="M8.48,8.92h-7a.25.25,0,0,1-.24-.25v.06A.25.25,0,0,0,1.52,9h7a.25.25,0,0,0,.24-.25V8.67A.25.25,0,0,1,8.48,8.92Z"
                    fill="#1a237e"
                    opacity="0.2"
                />
                <path d="M1.52,3.23h7a.25.25,0,0,1,.24.25v0a.25.25,0,0,0-.24-.25h-7a.25.25,0,0,0-.24.25v0A.25.25,0,0,1,1.52,3.23Z" fill="#fff" opacity="0.2" />
                <path
                    d="M3.45,5.83v.5h.71a.67.67,0,0,1-.71.52.8.8,0,0,1,0-1.6.73.73,0,0,1,.51.2H4l.37-.38a1.27,1.27,0,0,0-.88-.35,1.33,1.33,0,0,0,0,2.66,1.22,1.22,0,0,0,1.26-1.3,2,2,0,0,0,0-.25Z"
                    fill="#fff"
                />
                <g opacity="0.2">
                    <path d="M3.47,6.33v0h.69l0,0Z" fill="#1a237e" opacity="0.2" />
                    <path
                        d="M3.47,7.38a1.33,1.33,0,0,1-1.32-1.3v0A1.32,1.32,0,0,0,3.47,7.43,1.21,1.21,0,0,0,4.72,6.14v0A1.21,1.21,0,0,1,3.47,7.38Z"
                        fill="#1a237e"
                        opacity="0.2"
                    />
                    <path
                        d="M4,5.45a.72.72,0,0,0-.5-.2.8.8,0,0,0-.78.8v0a.8.8,0,0,1,.78-.78.72.72,0,0,1,.5.2H4l.4-.4,0,0L4,5.45Z"
                        fill="#1a237e"
                        opacity="0.2"
                    />
                </g>
                <path d="M7.51,5.22v0a.11.11,0,0,1-.11.11H5.31v0H7.4A.11.11,0,0,0,7.51,5.22Z" fill="#1a237e" opacity="0.2" />
                <path d="M7.4,7.38H5.31v0H7.4a.11.11,0,0,0,.11-.11V7.27A.11.11,0,0,1,7.4,7.38Z" fill="#1a237e" opacity="0.2" />
                <path d="M7.72,6.33H5.31v0H7.72a.11.11,0,0,0,.11-.11v0A.11.11,0,0,1,7.72,6.33Z" fill="#1a237e" opacity="0.2" />
                <path
                    d="M9.65,3.11l-1.8-.49V1.27A.25.25,0,0,0,7.6,1H2.4a.25.25,0,0,0-.25.25V2.62L.33,3.29A.23.23,0,0,0,.2,3.6l1.08,3V8.73A.25.25,0,0,0,1.52,9h7a.25.25,0,0,0,.24-.25V7.5L9.81,3.41A.23.23,0,0,0,9.65,3.11Z"
                    fill="url(#b)"
                />
            </g>
        </SvgIcon>
    );
};
